var customerSaySlider = new Swiper(".customer-say-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      990: {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 32,
      }
    }
});